import React from 'react';

export const AppContext = React.createContext({});
export const HeaderContext = React.createContext({});



// WEBPACK FOOTER //
// ./src/Context.ts